import { GTM_EVENT } from '../../../../utilities/constants';

export function getCurrentLocation(path) {
  // Regular Expresion to check if the path contains /plan but only last slash is optional and can not be followed by confirmation
  const planPathRegex = /\/?plan(?!\/confirmation)/;
  // Test path value against planPathRegex
  const isPlanPath = planPathRegex.test(path);
  // If isPlanPath is true return standard_purchase
  if (isPlanPath) return GTM_EVENT.PURCHASE_LOCATION.standard_purchase;

  // Regular Expresion to check if the path contains ANYNUMBER/check-in while the slashes are optional
  const preCheckinPathRegex = /\/?\d+\/check-in/;
  // Test path value against preCheckinPathRegex
  const isPreCheckinPath = preCheckinPathRegex.test(path);
  // If isPreCheckinPath is true return pre_checkin
  if (isPreCheckinPath) return GTM_EVENT.PURCHASE_LOCATION.pre_checkin;

  // Regular Expresion to check if the path contains /my-reservations/ANYNUMBER or plan/confirmation
  const myReservationsPathRegex = /\/?my-reservations\/?/;
  const planConfirmationPathRegex = /\/?plan\/confirmation\/?/;
  // Test path value against myReservationsPathRegex
  const isMyReservationsPath = myReservationsPathRegex.test(path) || planConfirmationPathRegex.test(path);
  // If isMyReservationsPath is true return my_reservations
  if (isMyReservationsPath) return GTM_EVENT.PURCHASE_LOCATION.post_package_purchase;

  // Regular Expresion to check if the path contains /plan but only last slash is optional and can not be followed by confirmation
  const birthdayPathRegex = /\/?birthday-parties\/?/;
  // Test path value against birthdayPathRegex
  const isBirthdayPath = birthdayPathRegex.test(path);
  // If isPlanPath is true return standard_purchase
  if (isBirthdayPath) return GTM_EVENT.PURCHASE_LOCATION.standard_purchase;

  return null;
}
